import { Link } from "react-router-dom";

const FEATURES = [
  { icon: "🎯", title: "Lead Capture QR", desc: "Collect customer name, email, and phone before redirecting. Every lead saved automatically." },
  { icon: "⭐", title: "Review Filter QR", desc: "Send happy customers to Google reviews. Keep negative feedback private." },
  { icon: "💳", title: "UPI Payment QR", desc: "Accept payments via PhonePe, GPay, Paytm with pre-filled details." },
  { icon: "🍽️", title: "Smart Menu QR", desc: "Digital menu with photos, prices, and real-time availability updates." },
  { icon: "📶", title: "WiFi QR", desc: "Auto-connect customers to WiFi — no password typing." },
  { icon: "📊", title: "Real-Time Analytics", desc: "Country, city, device, browser, IP, and hour tracked per scan." },
];

export default function DynamicQRIndia() {
  return (
    <div style={{ background: "#020617", color: "white", minHeight: "100vh", fontFamily: "'Inter', sans-serif" }}>
      <style>{`* { box-sizing: border-box; margin: 0; padding: 0; } a { color: inherit; }`}</style>

      {/* Nav */}
      <nav style={{ padding: "16px 24px", borderBottom: "1px solid #1e293b", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Link to="/" style={{ fontWeight: 900, fontSize: 20, fontStyle: "italic", textDecoration: "none", color: "white" }}>Digitoly QR</Link>
        <Link to="/login" style={{ background: "#ef4444", color: "white", padding: "10px 20px", borderRadius: 10, fontWeight: 700, fontSize: 13, textDecoration: "none" }}>Start Free Trial</Link>
      </nav>

      {/* Hero */}
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "64px 24px 48px", textAlign: "center" }}>
        <div style={{ display: "inline-block", background: "rgba(239,68,68,0.15)", color: "#fca5a5", border: "1px solid rgba(239,68,68,0.3)", padding: "5px 16px", borderRadius: 999, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: 2, marginBottom: 20 }}>
          #1 Dynamic QR Code Generator in India
        </div>
        <h1 style={{ fontSize: "clamp(32px, 5vw, 52px)", fontWeight: 900, lineHeight: 1.1, marginBottom: 20 }}>
          Dynamic QR Code Generator<br />
          <span style={{ color: "#ef4444" }}>with Real-Time Analytics</span><br />
          — Made for Indian Business
        </h1>
        <p style={{ fontSize: 17, color: "#94a3b8", lineHeight: 1.8, maxWidth: 640, margin: "0 auto 36px" }}>
          Create trackable, editable QR codes for your business in seconds. Change the destination URL anytime without reprinting.
          Every scan tracked with location, device, and time data. No technical knowledge required.
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <Link to="/login" style={{ background: "#ef4444", color: "white", padding: "16px 36px", borderRadius: 14, fontWeight: 900, fontSize: 14, textDecoration: "none", textTransform: "uppercase", letterSpacing: 1 }}>
            Start Free — 7 Days Full Access
          </Link>
          <Link to="/" style={{ background: "transparent", color: "white", border: "1px solid rgba(255,255,255,0.2)", padding: "16px 36px", borderRadius: 14, fontWeight: 700, fontSize: 14, textDecoration: "none" }}>
            See All Features →
          </Link>
        </div>
      </div>

      {/* What is Dynamic QR */}
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "0 24px 48px" }}>
        <div style={{ background: "#0f172a", border: "1px solid #1e293b", borderRadius: 20, padding: "36px" }}>
          <h2 style={{ fontSize: 26, fontWeight: 900, marginBottom: 16 }}>What is a Dynamic QR Code?</h2>
          <p style={{ color: "#94a3b8", lineHeight: 1.9, fontSize: 15, marginBottom: 16 }}>
            A <strong style={{ color: "white" }}>dynamic QR code</strong> is a QR code where the destination can be changed anytime —
            without reprinting the QR. Unlike static QR codes which are permanently fixed once printed,
            dynamic QR codes let you update the URL, redirect to different pages, and track every scan.
          </p>
          <p style={{ color: "#94a3b8", lineHeight: 1.9, fontSize: 15, marginBottom: 16 }}>
            When someone scans a dynamic QR code created on Digitoly, we record the scan with country,
            city, IP address, device type (Mobile/Desktop), browser, and exact hour — giving you
            real intelligence about your audience.
          </p>
          <p style={{ color: "#94a3b8", lineHeight: 1.9, fontSize: 15 }}>
            Dynamic QR codes are used by restaurants, retailers, event organizers, marketing agencies,
            hotels, clinics, and any business that prints marketing materials and wants to track results.
          </p>
        </div>
      </div>

      {/* Features grid */}
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "0 24px 48px" }}>
        <h2 style={{ fontSize: 28, fontWeight: 900, marginBottom: 8, textAlign: "center" }}>8 QR Code Types in One Platform</h2>
        <p style={{ color: "#64748b", textAlign: "center", marginBottom: 32, fontSize: 15 }}>
          Every QR mode is built for a specific business purpose — not just a URL redirect.
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 16 }}>
          {FEATURES.map((f, i) => (
            <div key={i} style={{ background: "#0f172a", border: "1px solid #1e293b", borderRadius: 16, padding: "24px" }}>
              <div style={{ fontSize: 28, marginBottom: 10 }}>{f.icon}</div>
              <h3 style={{ fontSize: 15, fontWeight: 900, marginBottom: 8 }}>{f.title}</h3>
              <p style={{ color: "#64748b", fontSize: 13, lineHeight: 1.7 }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Why Digitoly */}
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "0 24px 48px" }}>
        <h2 style={{ fontSize: 28, fontWeight: 900, marginBottom: 24 }}>Why Indian Businesses Choose Digitoly QR</h2>
        {[
          ["UPI Payment Support", "We are one of the only QR platforms that natively generates UPI payment QR codes — supporting PhonePe, GPay, Paytm, BHIM, and all UPI apps."],
          ["Built for India", "INR pricing, Indian phone number support, local business use cases like restaurant menus, review management, and loyalty programs."],
          ["No Reprinting Required", "Change your destination URL, update your offer, or fix a broken link instantly — your printed QR code automatically goes to the new URL."],
          ["Enterprise Analytics", "Track scans from any city in India or worldwide. See which hour of the day your QRs are scanned most. View device and browser breakdown."],
          ["7-Day Free Trial", "Full Agency-level access for 7 days — no credit card required. Create up to 50 QR codes, use all modes, and access all analytics."],
        ].map(([title, body], i) => (
          <div key={i} style={{ display: "flex", gap: 16, marginBottom: 20, alignItems: "flex-start" }}>
            <span style={{ color: "#22c55e", fontSize: 20, marginTop: 2 }}>✓</span>
            <div>
              <strong style={{ fontSize: 15, display: "block", marginBottom: 4 }}>{title}</strong>
              <span style={{ color: "#64748b", fontSize: 14, lineHeight: 1.7 }}>{body}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Pricing */}
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "0 24px 48px" }}>
        <h2 style={{ fontSize: 28, fontWeight: 900, marginBottom: 8, textAlign: "center" }}>Simple Pricing in INR</h2>
        <p style={{ color: "#64748b", textAlign: "center", marginBottom: 32 }}>All plans include a 7-day free trial. Pay via UPI, card, or net banking.</p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 16 }}>
          {[
            { name: "Free", price: "₹0", desc: "5 QR codes, direct mode only", highlight: false },
            { name: "Pro", price: "₹499/mo", desc: "50 QRs, all modes, full analytics", highlight: true },
            { name: "Agency", price: "₹1,499/mo", desc: "Unlimited QRs, bulk, team members", highlight: false },
          ].map((p, i) => (
            <div key={i} style={{ background: p.highlight ? "linear-gradient(135deg,rgba(239,68,68,0.15),rgba(168,85,247,0.1))" : "#0f172a", border: p.highlight ? "1px solid rgba(239,68,68,0.4)" : "1px solid #1e293b", borderRadius: 20, padding: "28px", textAlign: "center" }}>
              <p style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", color: "#64748b", letterSpacing: 2, marginBottom: 8 }}>{p.name}</p>
              <p style={{ fontSize: 32, fontWeight: 900, marginBottom: 8 }}>{p.price}</p>
              <p style={{ color: "#64748b", fontSize: 13, marginBottom: 20 }}>{p.desc}</p>
              <Link to="/login" style={{ display: "block", background: p.highlight ? "#ef4444" : "rgba(255,255,255,0.05)", color: "white", padding: "12px", borderRadius: 12, fontWeight: 700, fontSize: 12, textDecoration: "none", textTransform: "uppercase" }}>
                {p.highlight ? "Start Free Trial" : "Get Started"}
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* FAQ */}
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "0 24px 64px" }}>
        <h2 style={{ fontSize: 28, fontWeight: 900, marginBottom: 24 }}>Frequently Asked Questions</h2>
        {[
          ["What is the best dynamic QR code generator in India?", "Digitoly QR is built specifically for Indian businesses with UPI payment QR, INR pricing, and support for Indian phone numbers and business use cases like restaurant menus and review management."],
          ["Can I change the destination of a QR code after printing?", "Yes — that is the main advantage of dynamic QR codes. You can change the URL, redirect destination, or even switch QR modes anytime from your dashboard. The printed QR automatically updates."],
          ["How do I track QR code scans?", "Every scan on Digitoly is tracked automatically. You can see the country, city, device type, browser, IP address, and exact hour of every scan from your analytics dashboard."],
          ["Is Digitoly QR free?", "Yes. You can start free with a 7-day trial that includes full Agency access — 50 QR codes and all features. After the trial, the free plan allows 5 QR codes in direct mode."],
          ["Does Digitoly support UPI QR codes?", "Yes. Digitoly QR is one of the only platforms that natively generates UPI payment QR codes compatible with PhonePe, Google Pay, Paytm, and all UPI apps."],
        ].map(([q, a], i) => (
          <details key={i} style={{ borderBottom: "1px solid #1e293b", padding: "16px 0" }}>
            <summary style={{ fontSize: 15, fontWeight: 700, cursor: "pointer", listStyle: "none", display: "flex", justifyContent: "space-between" }}>
              {q} <span style={{ color: "#ef4444" }}>+</span>
            </summary>
            <p style={{ color: "#64748b", lineHeight: 1.8, marginTop: 12, fontSize: 14 }}>{a}</p>
          </details>
        ))}
      </div>

      {/* CTA */}
      <div style={{ background: "#0f172a", borderTop: "1px solid #1e293b", padding: "48px 24px", textAlign: "center" }}>
        <h2 style={{ fontSize: 28, fontWeight: 900, marginBottom: 12 }}>Start Creating Dynamic QR Codes Today</h2>
        <p style={{ color: "#64748b", marginBottom: 28, fontSize: 15 }}>7-day free trial · No credit card · Cancel anytime</p>
        <Link to="/login" style={{ background: "#ef4444", color: "white", padding: "16px 48px", borderRadius: 14, fontWeight: 900, fontSize: 14, textDecoration: "none", textTransform: "uppercase", letterSpacing: 1 }}>
          Create Your First QR Free →
        </Link>
      </div>

      <footer style={{ padding: "24px", textAlign: "center", borderTop: "1px solid #1e293b" }}>
        <p style={{ color: "#334155", fontSize: 12 }}>© 2026 Digitoly QR · <a href="/privacy" style={{ color: "#475569" }}>Privacy</a> · <a href="/terms" style={{ color: "#475569" }}>Terms</a> · <a href="/help" style={{ color: "#475569" }}>Help</a></p>
      </footer>
    </div>
  );
}
